class PolicyContent extends HTMLElement {
  connectedCallback() {
    // Shopify's imported policies use bold paragraphs as headings and blank paragraphs as spacers.
    for (const paragraph of Array.from(this.children)) {
      if (paragraph.tagName !== 'P') continue;
      const text = paragraph.textContent.trim();
      if (!text) {
        if (!paragraph.querySelector(':not(span, strong, b, em, i, br)')) paragraph.remove();
        continue;
      }
      const emphasis = paragraph.querySelector('strong, b');
      const tag = /^\d+[.)]\s/.test(text) && emphasis?.textContent.trim() === text
        ? 'h2'
        : /^(?:Option|Cách)\s+\d+\s*:/i.test(text) ? 'h3' : null;
      if (!tag) continue;
      const heading = document.createElement(tag);
      heading.append(...paragraph.childNodes);
      paragraph.replaceWith(heading);
    }

    for (const contact of this.querySelectorAll(':scope > p, li')) {
      if (contact.classList.contains('policy-page__contact') || !/^\s*(?:Email|WhatsApp|Hotline)\s*:/i.test(contact.textContent)) continue;
      let item = contact;
      if (contact.tagName === 'P') {
        let list = contact.previousElementSibling;
        if (!list?.classList.contains('policy-page__contacts')) {
          list = document.createElement('ul');
          list.className = 'policy-page__contacts';
          contact.before(list);
        }
        item = document.createElement('li');
        item.append(...contact.childNodes);
        list.append(item, document.createTextNode('\n'));
        contact.remove();
      }
      item.classList.add('policy-page__contact');
      // Imported contact lines often make the entire value bold; the design emphasizes only the label.
      for (const bold of item.querySelectorAll('strong, b')) bold.replaceWith(...bold.childNodes);
      const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const label = node.textContent.match(/^\s*(?:Email|WhatsApp|Hotline)\s*:/i);
        if (!label) continue;
        node.splitText(label[0].length);
        const emphasis = document.createElement('strong');
        emphasis.textContent = node.textContent;
        node.replaceWith(emphasis);
        break;
      }
      const emailText = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      while (emailText.nextNode()) {
        const node = emailText.currentNode;
        const email = node.textContent.match(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/i);
        if (!email || node.parentElement.closest('a')) continue;
        const address = node.splitText(email.index);
        address.splitText(email[0].length);
        const link = document.createElement('a');
        link.href = `mailto:${email[0]}`;
        link.textContent = email[0];
        address.replaceWith(link);
        break;
      }
    }

    const textNodes = [];
    const text = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
    while (text.nextNode()) {
      if (!text.currentNode.parentElement.closest('strong, b, a, .policy-page__emphasis')) textNodes.push(text.currentNode);
    }
    for (const node of textNodes) {
      const matches = [...node.textContent.matchAll(/INSANE CLO|100% of the return shipping cost/gi)];
      if (!matches.length) continue;
      const fragment = document.createDocumentFragment();
      let start = 0;
      for (const match of matches) {
        fragment.append(node.textContent.slice(start, match.index));
        const emphasis = document.createElement('span');
        emphasis.className = 'policy-page__emphasis';
        if (match[0].startsWith('100%')) emphasis.classList.add('policy-page__emphasis--uppercase');
        emphasis.textContent = match[0];
        fragment.append(emphasis);
        start = match.index + match[0].length;
      }
      fragment.append(node.textContent.slice(start));
      node.replaceWith(fragment);
    }
  }
}

if (!customElements.get('policy-content')) {
  customElements.define('policy-content', PolicyContent);
}
